export default {
    title: "訂單結算",
    tabs1: "全部訂單",
    tabs2: "未確認",
    tabs3: "待付款",
    tabs4: "待確認",
    tabs5: "已確認收貨",
    tabs6: "已發貨",
    tabs7: "已收貨",
    tabs8: "全單取消",
    tabs9: "要求退貨",
    tabs10: "已退貨",
    search1: "訂單號：",
    search2: "更多篩選條件",
    search3: "開始日期：",
    search4: "結束日期：",
    search5: "選擇部門：",
    search6: "選擇下單員：",
    place1: "請輸入訂單號進行查詢",
    place2: "開始日期",
    place3: "結束日期",
    place4: "請選擇部門",
    place5: "請選擇下單員",
    list1: "時間：",
    list2: "小計：",
    table1: "訂單號",
    table2: "部門",
    table3: "子公司/分行",
    table4: "打單員",
    table5: "金額",
    excel: "導出Excel"
}